import { render, staticRenderFns } from "./RolesPermissionsForm.vue?vue&type=template&id=812a24e4&"
import script from "./RolesPermissionsForm.vue?vue&type=script&lang=js&"
export * from "./RolesPermissionsForm.vue?vue&type=script&lang=js&"
import style0 from "./RolesPermissionsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports